<template>
  <div class="page-service">

    <div v-for="(block, index) in services" :key="`${index}`">
      <info-block :data="block"></info-block>
    </div>

    <div class="container is-gap-top" data-aos="fade-in" data-aos-once="true">
      <div class="is-gap has-text-left is-gap-top-bottom">
        <div class="showdown" v-if="content" v-html="content" />
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import Util from '@/util'
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/site'

import InfoBlock from '@/pages/base/infoblock'

export default {
  name: 'page-service',
  props: {
    // msg: String
  },
  components: {
    InfoBlock,
  },
  data () {
    return {
      name: undefined,
      loading: false,
      isDesktop: true,
      services: [],
    }
  },
  computed: {
    Util: function () {
      return Util
    },

    service: function () {
      let name = this.name
      let found = _.find(this.services, (item) => item.name === name)
      return found
    },

    content: function () {
      let service = this.service
      return Util.string.showdown(service && service.content)
    },
  },
  watch: {
    '$route.params.name': async function () {
      this.loadRoute()
      await this.refresh()
    }
  },
  created () {
    this.loadRoute()
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    await this.refresh()
  },
  methods: {
    loadRoute () {
      if (this.$route.params.name) {
        this.$set(this, 'name', this.$route.params.name)
      }
    },

    async refresh () {
      try {
        this.$set(this, 'loading', true)
        let promises = []
        let promise
        promise = this.getService(this.name)
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getService (name) {
      this.$set(this, 'services', [])
      if (Util.string.isBlank(name)) throw new Error('invalid service name')
      let data = await Site.serviceNamed(name)
      // data = _.map(data, (item) => {
      //   item.meta = {
      //     arrangement: 'left-header-right-image',
      //     container: {
      //       class: 'color-green-bg'
      //     }
      //   }
      //   return item
      // })
      this.$set(this, 'services', data)
    },
  }
}
</script>

<style lang="scss" src="../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../styles/app_setting.scss";

.page-service {
  .rounded-wrapper {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background-color: lightgray;
    background-repeat: no-repeat;
    background-color: #dedede;
    background-position: 50% 50%;
    background-size: auto 100%;
  }
}

</style>
